import type { LocationId } from '@brightlocal/shared';

import {
  BrainRecommendationsResponseSchema,
  InsightsStatusResponseSchema,
  LocationScoreResponseSchema
} from './schema';
import { HTTP_METHOD } from '../../../consts';
import type { ApiCallOptions, Transport } from '../../../types';

export const createInsightsApi = (transport: Transport) => ({
  getInsightsStatus: (locationId: LocationId, options?: ApiCallOptions) =>
    transport(`/manage/v1/brain/locations/${locationId}/status`, {
      method: HTTP_METHOD.GET,
      deserializer: InsightsStatusResponseSchema,
      signal: options?.signal
    }),

  getRecommendations: (locationId: LocationId, options?: ApiCallOptions) =>
    transport(`/manage/v1/brain/locations/${locationId}/recommendations`, {
      method: HTTP_METHOD.GET,
      deserializer: BrainRecommendationsResponseSchema,
      signal: options?.signal
    }),

  getLocationScore: (locationId: LocationId, options?: ApiCallOptions) =>
    transport(`/manage/v1/brain/locations/${locationId}/score`, {
      method: HTTP_METHOD.GET,
      deserializer: LocationScoreResponseSchema,
      signal: options?.signal
    })
});

export type InsightsApi = ReturnType<typeof createInsightsApi>;
